import {
  IPubsub_Message_Payload,
  IPubsub_Message_Type,
  IPubsub_Message_Body,
  IPubsub_Message_Type_Job,
  IPubsub_Message_Body_Job,

  IPubsub_Command_Type,
  IPubsub_Command_Body,
  IPubsub_Command_Type_Job_Get,
  IPubsub_Command_Body_Job_Get,

  IPubsub_Message_Body_Job_Log,

  IPubsub_Socket_Writer,
  IPubsub_Socket_Dispatcher,
  IPubsub_Client,
  
} from '../types/pubsub'

import {
  IRecord_Job,
} from '../types/schema/job'

import bluebird from 'bluebird'

import {
  getJobChannel,
} from './channels'

import {
  isJobFinished,
} from '../utils/job'

import {
  PUBSUB_WAIT_FOR_JOB_POLLING_INTERVAL,
  PUBSUB_WAIT_FOR_JOB_CHECK_INTERVAL,

  PUBSUB_HANDLER_TYPE_READ,
  PUBSUB_HANDLER_TYPE_COMMAND,

  PUBSUB_MESSAGE_TYPE_JOB_LOG,
  PUBSUB_MESSAGE_TYPE_JOB_UPDATE,
  
  PUBSUB_COMMAND_TYPE_JOB_GET
} from '../constants'

// get a function that will write the given message / body type to a web soccket
export function getWebsocketMessageDispatcher<MessageType = IPubsub_Message_Type, BodyType = IPubsub_Message_Body> (
  socketWriter: IPubsub_Socket_Writer,
  channel: string,
  messageType: MessageType,
): IPubsub_Socket_Dispatcher<BodyType> {
  const dispatch = (
    body: BodyType,
  ) => {
    const message: IPubsub_Message_Payload<MessageType, BodyType> = {
      handler: PUBSUB_HANDLER_TYPE_READ,
      channel,
      messageType,
      body,
    }
    socketWriter(message)
  } 
  return dispatch
}

export function getWebsocketCommandDispatcher<MessageType = IPubsub_Command_Type, BodyType = IPubsub_Command_Body> (
  socketWriter: IPubsub_Socket_Writer,
  messageType: MessageType,
): IPubsub_Socket_Dispatcher<BodyType> {
  const dispatch = (
    body: BodyType,
  ) => {
    const message: IPubsub_Message_Payload<MessageType, BodyType> = {
      handler: PUBSUB_HANDLER_TYPE_COMMAND,
      messageType,
      body,
    }
    socketWriter(message)
  } 
  return dispatch
}

export async function waitForJob (
  socketClient: IPubsub_Client<IPubsub_Message_Type_Job, IPubsub_Message_Body_Job>,
  id: string,
  onLog: {
    (st: string): void,
  },
  // by default we wait 10 minutes for a job to complete
  timeout = 1000 * 60 * 10,
) {//: Promise<IRecord_Job> {
  const channel = getJobChannel(id)
  const getJobDispatcher = getWebsocketCommandDispatcher<IPubsub_Command_Type_Job_Get, IPubsub_Command_Body_Job_Get>(
    socketClient.send,
    PUBSUB_COMMAND_TYPE_JOB_GET,
  )
  const getJobInterval = setInterval(() => {
    getJobDispatcher({
      id,
    })
  }, PUBSUB_WAIT_FOR_JOB_POLLING_INTERVAL)
  const cleanup = async () => {
    socketClient.unsubscribe(channel)
    clearInterval(getJobInterval)
  }
  const started = new Date()
  try {
    let currentJob: IRecord_Job | null = null

    // subscribe to job events
    await socketClient.subscribe(channel, async (message) => {
      if(message.messageType == PUBSUB_MESSAGE_TYPE_JOB_LOG) {
        // loop over the logs an emit them
        (message.body as IPubsub_Message_Body_Job_Log).forEach(onLog)
      }
      else if(message.messageType == PUBSUB_MESSAGE_TYPE_JOB_UPDATE) {
        // update the current job data
        currentJob = message.body as IRecord_Job
      }
    })

    // send an initial get job command so we have the job right away
    getJobDispatcher({
      id,
    })

    // loop waiting for the job to finish
    while(!currentJob || !isJobFinished(currentJob)) {
      if((new Date().getTime() - started.getTime()) > timeout) throw new Error(`job timed out after ${timeout} ms`)
      await bluebird.delay(PUBSUB_WAIT_FOR_JOB_CHECK_INTERVAL)
    }

    cleanup()
    return currentJob
  } catch(e) {
    cleanup()
    throw e
  } 
}

// given a list of subscription channels with perhaps wildcards
// match the given channel to them and return matching channels
export const getMatchingChannels = (
  subscribed: string[],
  channel: string,
): string[] => {
  return subscribed.filter(subscribe_channel => {
    if(!subscribe_channel.match(/\.\*$/)) return subscribe_channel == channel
    return channel.indexOf(subscribe_channel.replace(/\*$/, '')) == 0;
  });
}
